<template>
  <card header-classes="bg-transparent">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Sperrabfragen</h6>
        <h5 class="h3 mb-0">Top oder Flop</h5>
      </div>
    </div>

    <bar-chart
        :height="350"
        ref="barChart"
        :chart-data="redBarChart.chartData"
    >
    </bar-chart>
  </card>
</template>
<script>
import BarChart from '@/components/Charts/BarChart'

export default {
  name: 'TopFlopChart',
  components: {BarChart},
  props: {
    from: {
      type: String
    },
    to: {
      type: String
    }
  },
  data() {
    return {
      locksByDurationTodayOngoing: {
        oneMonthAndSmaller: 0,
        betweenOneAndThreeMonth: 0,
        betweenThreeAndSixMonth: 0,
        betweenSixAndTwelveMonth: 0,
        oneYearAndLater: 0
      },
      redBarChart: {
        chartData: {
          labels: [],
          datasets: [{
            label: 'Spielersperren',
            data: [25, 20, 30, 22, 17, 29]
          }]
        }
      }
    }
  },
  created() {
    this.init()
  },
  watch: {
    from: function () {
      this.init()
    },
    to: function () {
      this.init()
    }
  },
  methods: {
    getData(from, to) {
      return new Promise((resolve, reject) => {
        const header = this.authHeader();
        header['Content-Type'] = 'application/json';
        const requestOptions = {
          method: 'GET',
          headers: header
        };

        let url = process.env.VUE_APP_API_SERVER + `/stats/ranking`;
        if (from !== null) url = url + `/` + from;
        if (to !== null) url = url + `/` + to;


        fetch(url, requestOptions)
            .then(this.handleResponse)
            .then(response => {
              resolve(response);
            }, error => {
              reject(error);
            });
      });
    },
    init() {
      this.getData(this.from,this.to).then(
          response => {
            this.requests = response
            this.initChart()
          },
          error => {
            if (error.toString().includes('NetworkError when attempting')) {
              this.$store.dispatch('alert/warn', 'Das Laden dauert zu lange. Verkürzen Sie die Zeitspanne oder beschränken Sie die Abfrage auf einen Standort.')
            } else {
              this.$store.dispatch('alert/error', error)
            }
          }
      )
    },
    initChart() {
      let data = this.requests;
      let transdata = [];
      let translabel = [];
      data.forEach(element => {
        transdata.push(element.prcount);
        translabel.push(element.loc)
      });
      let chartData = {
        datasets: [
          {
            label: 'Spielerabfragen',
            data: transdata
          }
        ],
        labels: translabel,
      };
      this.redBarChart.chartData = chartData;
    },
  }
}
</script>